module.exports = __webpack_public_path__ + "app/principal/modals/modal-export-reminder-2SnJ58U-.html";